export const ISSUER_SYS_NAME = 'ISSUER_SYS_NAME';
export const JWT_AUTH = 'JWT_AUTH';
